import React from 'react';
import { Link } from 'react-router-dom';
import { Origin } from '@upstart/harmony/lib/constants';
import { Button, Icon } from 'semantic-ui-react';
import { sendData } from '../../../../util/amplitude';
import { amplitudeEvents } from '../../../../util/amplitudeEvents';
import './CustomerAndCreditApp.scss';

export interface CustomerAndCreditAppProps {
  dealId: string;
  vin?: string;
  customerName?: string;
  onEditCustomer: () => void;
  creditScore?: number;
}

const CustomerAndCreditApp: React.FC<CustomerAndCreditAppProps> = ({
  customerName,
  creditScore,
  onEditCustomer,
  dealId,
  vin,
}) => {
  const editCustomerHandler = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    e.preventDefault();
    onEditCustomer();
  };
  return (
    <div className="customer-credit-app-wrapper">
      <div className="customer">
        <span data-dd-privacy="mask">{customerName}</span>
        <Button
          basic
          onClick={e => editCustomerHandler(e)}
          className="edit-btn"
        >
          {customerName ? 'Edit' : 'Add Customer'}
        </Button>
      </div>
      <div className="credit-app">
        <div className="soft-pull">
          Soft pull <span className="credit-score">{creditScore || 'N/A'}</span>
        </div>
        <span className="divider" />
        <Link
          target="_blank"
          to={{
            pathname: `${process.env.REACT_APP_INSTORE_URL}/credit-application?dealId=${dealId}&from=${Origin.DESKING}`,
          }}
          onClick={() =>
            vin
              ? sendData(amplitudeEvents.OPEN_CREDIT_APP_FROM_DESKING, {
                  vin,
                })
              : sendData(amplitudeEvents.OPEN_CREDIT_APP_FROM_DESKING)
          }
          className="external-link"
        >
          <span>Credit app</span>
          <Icon name="external alternate" className="icon" />
        </Link>
      </div>
    </div>
  );
};

export default CustomerAndCreditApp;
